<template>
  <div class="container-fluid sale-detail mt-2" v-if="options">
    <div class="loading" v-if="loading">Loading&#8230;</div>

    <div class="page-header row my-1">
      <div class="col d-flex justify-content-between align-items-center flex-wrap">
        <h4 class="mb-0">{{ title }}</h4>
        <div class="d-flex" v-if="$route.name != 'Nuevo presupuesto' && $route.name != 'Nuevo remito de venta'">
          <button
            type="button"
            title="Seleccionar borrador"
            class="btn btn-outline-primary mr-2"
            @click="showDraftModal = true; getDrafts()">
            Cargar <i class="bi bi-box-arrow-in-up"></i>
          </button>
          <button
            type="button"
            title="Guardar venta"
            class="btn btn-primary"
            :disabled="loading || !(hasProducts && totalUpperToSixDigit && hasClient)"
            @click="saveDraft">
            Guardar <i class="bi bi-box-arrow-in-down"></i>
          </button>
        </div>
      </div>
    </div>

    <!-- CABECERA PUNTO DE VENTA -->
    <div class="row">
      <div class="col-12">
        <receipt-header
        @headerchanged="headerUpdated"
        @clientchanged="clientUpdated"
        :storage-key="storageKey"
        :show-pricelist="options.showPricelist"
        :show-prices="options.showPrices"
        :show-choosedate="options.showChoosedate"
        :show-pos="options.showPos"
        :posnumbers="options.posnumbers"
        :showservicedate="showservicedate"
        :config="options.config"
        />
      </div>
    </div>

    <!-- TABLA DE ADD PRODUCTOS -->
    <div class="row sale-detail__content-row">
      <div class="col-md-8 mb-4 mb-md-0 products-col">
        <receipt-products v-if="payload.header.pricelist_id"
        :show-prices="options.showPrices"
        :show-barcodes="options.showBarcodes"
        :keep-items="options.keepItemsState"
        @productschanged="productsUpdated"
        @sendProduct="sendProduct"
        :storage-key="storageKey"
        :config="options.config"
        :disciva="disciva"
        :allow_sale_without_stock="options.allow_sale_without_stock"
        :allow_edit_price="options.allow_price_edit"
        :discount_each_line="options.discount_each_line"
        :discount_each_line_type="options.discount_each_line_type"
        :prexistprd="options.prexistprd"
        :priceList="payload.header.pricelist_id"
        :productsAux='products'
        />
      </div>

      <!-- CUADRO TOTALES -->
      <div class="col-md-4 totals-col">
        <receipt-totals v-if="options.showPrices"
        v-bind:products="products"
        v-on:totalschanged="totalsUpdated"
        :disciva="disciva"
        :letter="payload.header.letter"
        :discount_each_line="options.discount_each_line"
        :discount_each_line_type="options.discount_each_line_type"
        :discount="payload.discount"
        :clientDiscount="clientDiscount"
        :grossTotal="payload.grossTotal"
        :priceTotal="payload.priceTotal"
        :initial-discount="options.bundleDiscount"
        :initial-discount-type="options.bundleDiscountType"/>

        <!-- NOTA + METODOS DE PAGO -->
        <div class="card notes-payment-card">
          <div class="card-body">
            <div class="card-title-group mb-2">
              <span class="card-title-icon">
                <i class="bi bi-sticky"></i>
              </span>
              <h6 class="mb-0">Nota para el cliente</h6>
            </div>
            <textarea v-model="payload.saleNote" class="form-control" rows="2"></textarea>

            <div class="totals-divider notes-payment-card__pago-divider"></div>

            <div class="card-title-group mb-2">
              <span class="card-title-icon">
                <i class="bi bi-credit-card"></i>
              </span>
              <h6 class="mb-0">Método de pago</h6>
            </div>
            <div class="row" v-if="title === 'Nueva Venta' || title === 'Editar Venta'">
              <div class="col-6">
                <button
                  type="button"
                  class="btn btn-lg btn-success btn-block p-2"
                  :disabled="loading || !(hasProducts && totalUpperToSixDigit && hasClient)"
                  @click="cashMethod">
                  Efectivo<i class="bi bi-coin ml-2"></i>
                </button>
              </div>
              <!-- Boton QR deshabilitado por el momento
              <div class="col-6">
                <button
                  type="button"
                  class="btn btn-lg btn-info btn-block"
                  :disabled="loading || !(hasProducts && totalUpperToSixDigit && hasClient)"
                  @click="mpqr">
                  QR<i class="bi bi-qr-code ml-2"></i>
                </button>
              </div>
              -->
              <div class="col-6">
                <button
                  type="button"
                  class="btn btn-lg btn-info btn-block p-2"
                  :disabled="loading || !(hasProducts && totalUpperToSixDigit && hasClient && clientType)"
                  @click="accountsMethod">
                  Cuenta Cte.<i class="bi bi-card-heading ml-2"></i>
                </button>
              </div>
              <div class="col-6 mt-2">
                <button
                  type="button"
                  class="btn btn-lg btn-outline-success btn-block p-2"
                  :disabled="loading || !(hasProducts && totalUpperToSixDigit && hasClient)"
                  @click="trans">
                  Transferencia<i class="ml-2 bi bi-arrow-left-right"></i>
                </button>
              </div>
              <!-- <div class="col-6 mt-2">
                <button
                  type="button"
                  class="btn btn-lg btn-outline-info btn-block"
                  :disabled="loading || !(hasProducts && totalUpperToSixDigit && hasClient)"
                  @click="card">
                  Tarjeta<i class="ml-2 bi bi-credit-card"></i>
                </button>
              </div> -->
              <div class="col-6 mt-2">
                <button
                  type="button"
                  class="btn btn-lg btn-orange btn-block p-2"
                  :disabled="loading || !(hasProducts && totalUpperToSixDigit && hasClient)"
                  @click="receiptComplete">
                  Editar<i class="bi bi-pencil-square ml-2"></i>
                </button>
              </div>
            </div>
            <div class="row" v-else>
              <div class="col-12">
                <button
                  type="button"
                  class="btn btn-orange btn-block p-2"
                  :disabled="loading || !(hasProducts && totalUpperToSixDigit && hasClient)"
                  @click="receiptComplete">
                  Finalizar
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- MODAL METODOS DE PAGO -->
      <receipt-payment-methods
      v-if="showModal"
      :header="payload.header"
      :fundDefault="options.config.fund_default"
      @paymentmethodschanged="paymentMethodsUpdated"
      @paymentmethodsclose="paymentMethodsClose"
      :payment-methods="options.payment_methods"
      :total="payload.total"
      :limited="true"
      :cc-only="payload.cc_only"
      :gen-type="options.genType"
      @close="showModal = false"/>

      <!-- MODAL TRANSFERENCIAS -->
      <receipt-transfer-modal
      v-if="showTransModal"
      :header="payload.header"
      :fundDefault="options.config.fund_default"
      @paymentmethodschanged="paymentMethodsUpdated"
      @paymentmethodsclose="paymentMethodsClose"
      :payment-methods="options.payment_methods"
      :total="payload.total"
      :limited="true"
      :gen-type="options.genType"
      @close="showTransModal = false"/>

      <!-- MODAL TARJETAS -->
      <receipt-creditcard-modal
      v-if="showCardModal"
      :header="payload.header"
      :fundDefault="options.config.fund_default"
      @paymentmethodschanged="paymentMethodsUpdated"
      @paymentmethodsclose="paymentMethodsClose"
      :payment-methods="options.payment_methods"
      :total="payload.total"
      :limited="true"
      :gen-type="options.genType"
      @close="showCardModal = false"/>

      <!-- MODAL BORRADORES -->
      <transition name="modal">
        <div v-if="showDraftModal" class="modal-mask-product">
          <div class="modal-dialog modal-lg">
            <div class="modal-content">
              <div class="form-card__header">
                <h6 class="form-card__title">
                  <i class="bi bi-files"></i>
                  Borradores de factura
                </h6>
                <button type="button" class="form-card__btn" @click="showDraftModal = false">
                  <i class="bi bi-x-lg"></i>
                </button>
              </div>
              <div class="modal-body form-card form-card--bare">
                <div class="table-responsive">
                  <table class="table table-sm">
                    <thead>
                      <tr>
                        <th></th>
                        <th class="text-center">Fecha</th>
                        <th>Nro Identificador</th>
                        <th class="text-center">Cliente</th>
                        <th>Pto Venta</th>
                        <th>Total</th>
                        <th>Vendedor</th>
                        <th>Acciones</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(saleDraft, index) in salesDraft" :key="index">
                        <td>
                          <input type="radio" name="selectedDraft" v-model="selectedDraft" :value="saleDraft.id">
                        </td>
                        <td>{{ formatoFechaHora(saleDraft.created_at) }}</td>
                        <td class="text-center">{{ saleDraft.id }}</td>
                        <td class="text-center">{{ saleDraft.client_name }}</td>
                        <td class="text-center">{{ saleDraft.pos }}</td>
                        <td class="text-center">{{ saleDraft.total }}</td>
                        <td class="text-center" v-if="saleDraft.salesclerk !== null">{{ saleDraft.salesclerk }}</td>
                        <td v-else></td>
                        <td>
                          <button type="button" class="btn btn-outline-danger" title="Borrar borrador" @click="deleteDraft(saleDraft.id)">
                            <i class="bi bi-dash-circle"></i>
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div class="form-card__footer">
                <button type="button" class="form-card__btn" @click="showDraftModal = false">Cancelar</button>
                <button type="button" class="form-card__btn form-card__btn--primary" :disabled="!selectedDraft" @click="getDraft">
                  <i class="bi bi-check-lg"></i>
                  Cargar
                </button>
              </div>
            </div>
          </div>
        </div>
      </transition>

  </div>
</template>


<script>
import receiptProducts from './Receipt-products.vue';
import receiptHeader from './Receipt-header.vue';
import receiptTotals from './Receipt-totals.vue';
import receiptPaymentMethods from '../paymentmethods/Receipt-payment-methods.vue';
import receiptTransferModal from '../paymentmethods/Receipt-transfer-modal.vue';
import receiptCreditcardModal from '../paymentmethods/Receipt-creditcard-modal.vue';
import { mapGetters, mapActions } from 'vuex'
import formatDateMixin from "../../../../mixins/formatDateMixin";

  export default {
    props: ['configurl'],
    mixins: [formatDateMixin],
    components: {
      receiptProducts,
      receiptHeader,
      receiptTotals,
      receiptPaymentMethods,
      receiptTransferModal,
      receiptCreditcardModal
    },
    data: function() {
      return {
        options: null,
        modalProduct: false,
        showModal: false,
        showTransModal: false,
        showCardModal: false,
        showDraftModal: false,
        disciva: false,
        products: [],
        salesDraft: [],
        saleDraft:[],
        selectedDraft: null,
        showservicedate: false,
        clientDiscount:null,
        ccLimit:null,
        config: null,
        payload: {
          header: JSON.parse(localStorage.getItem('header:' + (this.configurl || 'pos'))) || {},
          items: JSON.parse(localStorage.getItem('products:' + (this.configurl || 'pos'))) || [],
          discount: 0,
          p_discount:0,
          total: 0,
          paymentMethods: {},
          saleNote: '',
          fromReceipt: '',
          cc_only:0,
          grossTotal: 0,
          priceTotal: 0,
          draft: false
        },
        loading: false,
        title: '',
      }
    },
    mounted () {
      this.getConfiguration(this.configurl);
      this.getTitle();
      this.getFunds();
    },
    watch: {
      showConfiguration (newshowConfig) {
        if (typeof newshowConfig.config !== 'undefined') {
          this.options = newshowConfig;
          this.payload.saleNote = newshowConfig.note_default;
          this.payload.fromReceipt = newshowConfig.config.fromReceipt;
        }
      }
    },
    computed: {
      ...mapGetters({
        showConfiguration: 'config/showConfiguration',
        authUser: 'authUser/getUser'
      }),
      storageKey() {
        return this.configurl || 'pos';
      },
      isSale(){
        if(this.configurl === '/api/sales/create'){
          return true;
        }else {
          return false;
        }
      },
      hasProducts(){
        return (this.payload.items.length>0);
      },
      totalUpperToSixDigit() {
        if (this.payload.total >= 9999999999999.99) {
          alert('Se pas&oacute; el l&iacute;mite de $9.999.999.999.999,99, por favor ingrese menos productos.');
          return false;
        } else {
          return true;
        }
      },
      hasClient(){
        if(this.payload.header.client_id==null){
          return false;
        }else{
          return true;
        }
      },
      clientType(){
        if(this.payload.header.client_id == 1){
          return false;
        }else{
          return true;
        }
      },
      isOnlyCash(){
        return (this.options.payment_methods.cheques==0 && this.options.payment_methods.cuenta_corriente==0 && this.options.payment_methods.tarjetas==0);
      },
      isOnlyCashNC(){
        return (this.options.genType=='NC' && this.options.payment_methods.cuenta_corriente==0);
      }
    },
    methods: {
      ...mapActions({
        getConfiguration: 'config/getConfiguration',
        getFunds: 'funds/getFunds'
      }),
      mpqr: function () {
        axios.post('/api/sales/sendtoQR/' + this.payload.total)
      },
      round: function(value, decimals) {
        return (Number(Math.round(value + 'e' + decimals) + 'e-' + decimals));
      },
      calcprod : function() {
        var app = this;
        if (app.debug) {console.log('calculando productos');}
        let discountTotal=0;
        let grossTotal=0;
        let priceTotal=0;
        for (var i = 0; i < app.products.length; i++) {
          if ( (app.products[i].promorules.length > 0) && (typeof app.products[i].quantity == 'number') ) {
            var findi2 = -1;
            for (var i2 = 0; i2 < app.products[i].promorules.length; i2++) {
              if ((app.products[i].quantity >= app.products[i].promorules[i2].fromqty) && (app.products[i].quantity<app.products[i].promorules[i2].toqty)) {
                findi2 = i2;
              }
            }
            if (findi2>-1) app.products[i].price = app.products[i].promorules[findi2].price;
              else app.products[i].price=app.products[i].bkprice;
          }

          if(app.options.keepItemsState==true){

           if (app.products[i].includetax==1) {
              app.products[i].gross = app.products[i].price / (1+(app.products[i].taxtype/100));
            } else {
              app.products[i].gross = app.products[i].price;
            }
            app.products[i].tax = app.products[i].gross * app.products[i].taxtype/100;

          }else{

            if (app.products[i].includetax==1) {
              app.products[i].gross = app.products[i].price / (1+(app.products[i].taxtype/100));
            } else {
              app.products[i].gross = app.products[i].price;
            }
            app.products[i].tax = app.products[i].gross * app.products[i].taxtype/100;

          }

          if(app.options.discount_each_line==1){
            if(app.options.discount_each_line_type !== undefined && app.options.discount_each_line_type == 'amount'){
              discountTotal = discountTotal + app.products[i].discount * app.products[i].quantity;
            } else {
              if(app.options.disciva !== undefined && app.options.disciva == true)
                discountTotal = discountTotal + ((app.products[i].discount * app.products[i].grossprice)/ 100) * app.products[i].quantity;
              else
                discountTotal = discountTotal + ((app.products[i].discount * app.products[i].price)/ 100) * app.products[i].quantity;
            }
          }

          grossTotal = grossTotal + app.products[i].gross * app.products[i].quantity;
          priceTotal = priceTotal + app.products[i].price * app.products[i].quantity;
        }

        app.payload.grossTotal= grossTotal;
        app.payload.priceTotal= priceTotal;

        if(app.options.discount_each_line==1)
          app.payload.discount=discountTotal;
      },
      receiptComplete: function() {
        if(this.payload.total == 0 && this.showPrices)
          alert('No puede facturar por 0 pesos.');
        else {
          if (this.isOnlyCash || !this.options.showPaymentmethods || this.isOnlyCashNC){
            this.payload.paymentMethods={
              cash: this.payload.total,
              fund_id: this.options.config.fund_default,
              accounts: [],
              creditcards: [],
              tpchecks: []
            };
            this.sendReceipt();
          }else{
            this.showModal=true;
          }
        }
      },
      trans: function() {
        if(this.payload.total == 0 && this.showPrices)
          alert('No puede facturar por 0 pesos.');
        else {
          this.showTransModal=true;
        }
      },
      card: function() {
        if(this.payload.total == 0 && this.showPrices)
          alert('No puede facturar por 0 pesos.');
        else {
          this.showCardModal=true;
        }
      },

      sendReceipt: function() {
        var app=this;
        if (app.loading) { return; }
        app.loading = true;
        for (var i = 0; i < app.payload.items.length; i++) {
          delete app.payload.items[i].code;
          delete app.payload.items[i].barcode;
          delete app.payload.items[i].stock;
          delete app.payload.items[i].promorules;
        }
        if(this.title == 'Nueva Venta' || this.title == 'Editar Venta'){
          const {saleId} = app.$route.params
          if(saleId && saleId !== 'undefined'){
            axios.post('/api/sales/destroyDraft/' + saleId)
          }
        }

        if (app.debug) {console.log('payload'+' '+app.payload);}
        window.axios.post(app.options.endpointurl, app.payload)
        .then(function (response) {
          if (response.data.success) {
            localStorage.removeItem('header:' + app.storageKey);
            localStorage.removeItem('products:' + app.storageKey);
            if (response.data.data.printInvoice) {
              if (app.$route.name === "Nueva venta") {
                if (response.data.data.printTicket) {
                  if (app.authUser.company_id==182 || app.authUser.company_id==370) {
                    window.location.href = '/sales/ticketg/'+response.data.data.ID;
                  } else {
                    window.location.href = '/sales/ticket/'+response.data.data.ID;
                  }
                } else {
                  window.open(response.data.data.urlInvoice, '_blank');
                  window.location.href = window.location.pathname;
                }
              } else {
                if (response.data.data.printOrdernoteTicket) {
                  window.location.href = '/ordernotes/ticket/'+response.data.data.ID;
                } else {
                  window.open(response.data.data.urlInvoice, '_blank');
                  window.location.href = '/ventas/index/';
                }
              }

            } else {
              if(response.data.data.sendEmail) {
                if (response.data.data.clientEmail) {
                  alert("El email se envio correctamente");
                } else {
                  alert("El Cliente no tiene un email asignado");
                }
              }
              alert(response.data.data.responseText);
              if (!app.debug) {window.location.href = window.location.pathname;}
            }
          } else {
            alert(response.data.message);
          }
          app.loading = false;
        })
        .catch(function (error) {
          alert(error.response.data.message);
          app.loading = false;
          window.location.href = window.location.pathname;
        });
      },
      headerUpdated: function(obj) {
        var app = this;
        app.payload.header = obj;
        if (app.payload.header.letter=="A" || app.payload.header.letter=="M") {
          app.disciva=true;
        } else {
          app.disciva=false;
        }
        app.calcprod();
        localStorage.setItem('header:' + app.storageKey, JSON.stringify(obj));
      },
      clientUpdated:function(id){
        var app = this;
        if (id!=null) {
          window.axios.get('/api/clients/getClient/'+id)
          .then(function (response) {
            var client = response.data.data;
            if (client.discount>"0") {
              app.clientDiscount = client.discount;
            }
            app.ccLimit = client.ccLimit;
            app.payload.cc_only = client.cc_only;
          }).catch(function (error) {
            alert(error.message);
          });
        }
      },
      clearproducts: function () {
        this.products = this.products.filter(el => (el.id !== 0 || el.type == 'LABEL'));
        this.calcprod();
      },
      paymentMethodsUpdated: function(obj) {
        var vm = this;
        vm.payload.paymentMethods = obj;
        if (Object.keys(obj).length === 0 && obj.constructor === Object) {
          vm.clearproducts();
        } else {
          if (vm.payload.paymentMethods.creditcards.length > 0) {
            console.log('tarjeta detectada!');
            var interests = vm.payload.paymentMethods.creditcards.map( e => e.interest).reduce((acc, currentValue) => acc + currentValue, 0);
            if (interests > 0) {
            var newitem = {
                            quantity: 1,
                            id: 0,
                            price: interests,
                            bkprice: interests,
                            name: "Intereses por tarjeta",
                            includetax: 1,
                            taxtype: "21",
                            type: "CARD",
                            unit: "U",
                            gross: interests / (1+(21/100)),
                            tax: (interests / (1+(21/100))) * 21/100,
                            barcode: null,
                            code: null,
                            promorules: [],
                            stock:0,
                          };
              vm.products.push(newitem);
              vm.calcprod();
            }
          }
        }
      },
      paymentMethodsClose: function(obj) {
        var pass = true;
        var app = this;
        app.payload.paymentMethods = obj;
        if ((app.payload.paymentMethods.accounts.length>0) && (app.ccLimit!=null) &&(app.ccLimit<app.payload.paymentMethods.accounts[0].amount)){
          if (confirm("La cuenta corriente excederá su límite ¿Realizar la venta de todas maneras?") == false){
            pass = false;
          }
        }

        if (pass == true){
          this.paymentMethodsUpdated(obj);
          this.productsUpdated(this.products);
          this.sendReceipt();
        }
      },
      productsUpdated: function(obj) {
        this.payload.items = obj;
        this.products = obj;
        this.calcprod();
        this.showservicedate=false;
        localStorage.setItem('products:' + this.storageKey, JSON.stringify(this.products));
        for (var i = 0; i < obj.length; i++) {
          if (obj[i].type=='SERVICE') { this.showservicedate=true; return; }
        }
      },
      totalsUpdated: function(obj) {
        this.payload.discount = obj.tdiscount;
        this.payload.p_discount = obj.pdiscount;
        this.payload.subtotal = this.round(obj.net,2);
        this.payload.total = this.round(obj.total,2);
      },
      sendProduct(product) {
        this.products.push(product);
        this.calcprod();
        this.productsUpdated(this.products);
      },
      saveDraft(){
        if(this.options.id == undefined){
          this.payload.draft = true;
          this.payload.paymentMethods={
            banks:[],
            cash: this.payload.total,
            fund_id: this.options.config.fund_default,
            fundBanks_id: [],
            accounts: [],
            creditcards: [],
            tpchecks: []
          };
          axios.post('/api/sales/addDraft', this.payload)
          .then((response) => {
            if (!response || !response.data || !response.data.success) {
              alert('No se pudo guardar el borrador. Intentá de nuevo.');
              return;
            }
            localStorage.removeItem('header:' + this.storageKey);
            localStorage.removeItem('products:' + this.storageKey);
            this.$router.replace('/temporal');
            this.$nextTick(() => {
              this.$router.replace({
                name: 'Nueva venta',
              });
            });
          })
          .catch(() => {
            alert('No se pudo guardar el borrador. Intentá de nuevo.');
          });
        }else{
          let id = this.options.id;
          axios.post('/api/sales/updateDraft/' + id, this.payload)
          .then((response) => {
            if (!response || !response.data || !response.data.success) {
              alert('No se pudo guardar el borrador. Intentá de nuevo.');
            }
          })
          .catch(() => {
            alert('No se pudo guardar el borrador. Intentá de nuevo.');
          });
        }
      },
      getDrafts(){
        axios.get('/api/sales/getalldrafts')
          .then((response) => {
            this.salesDraft = response.data.data;
          });
      },
      getDraft() {
        var app = this;
        if (!app.selectedDraft) return;
        if (app.hasProducts && !confirm('Tenés productos cargados sin guardar. ¿Descartarlos y cargar el borrador seleccionado?')) {
          return;
        }
        localStorage.removeItem('header:' + app.storageKey);
        localStorage.removeItem('products:' + app.storageKey);
        app.payload.draft = app.selectedDraft;
        this.showDraftModal = false;
        this.$router.replace('/temporal');
        this.$nextTick(() => {
          this.$router.replace({
            name: 'Editar venta',
            params: { saleId: app.selectedDraft }
          });
        });
      },
      deleteDraft(id){
        if (confirm("¿Está seguro que desea eliminar este borrador?") == true) {
          axios.post('/api/sales/destroyDraft/' + id)
          .then((response) => {
            if (response.data.code == 200) {
              console.log('Borrador eliminado!');
              this.getDrafts();
            }
          }).catch((error) => {
            console.error('Error al eliminar el borrador:', error);
          });
        }
      },
      cashMethod() {
        var app = this;
        if(app.payload.header.pos!=0 && (app.payload.header.letter=='C' || app.payload.header.letter=='B') && app.payload.total >= 500000){
          alert('Debe informar CUIT/DNI del cliente si el monto es igual o superior a $500.000');
        }else{
          app.payload.paymentMethods={
            banks:[{ amount: 0 }],
            cash: this.payload.total,
            fund_id: this.options.config.fund_default,
            fundBanks_id: [],
            accounts: [],
            creditcards: [],
            tpchecks: []
          };
          this.sendReceipt();
        }
      },
      accountsMethod() {
        var app = this;
        var pass = true;
        if(confirm("Desea cerrar esta venta en cuenta corriente?") == true){
          app.payload.paymentMethods={
            banks:[{ amount: 0 }],
            cash: 0,
            fund_id: 0,
            fundBanks_id: [],
            accounts: [{ amount: this.payload.total, days: 30 }],
            creditcards: [],
            tpchecks: []
          };
          if ((app.payload.paymentMethods.accounts.length>0) && (app.ccLimit!=null) &&(app.ccLimit<app.payload.paymentMethods.accounts[0].amount)){
            if (confirm("La cuenta corriente excederá su límite ¿Realizar la venta de todas maneras?") == false){
              pass = false;
            }
          }
          if (pass == true){
            this.sendReceipt();
          }
        }
      },
      getTitle(){
        switch(this.configurl){
          case '/api/sales/create':
            this.title = 'Nueva Venta';
            console.log(this.title);
            break;
          case '/api/creditnotes/create':
            this.title = 'Nueva Nota de Credito';
            break;
          case '/api/debitnotes/create':
            this.title = 'Nueva Nota de Debito';
            break;
          case '/api/budgets/create':
            this.title = 'Nuevo Presupuesto';
            break;
          case '/api/ordernotes/create':
            this.title = 'Nueva Nota de pedido';
            break;
          case '/api/shippingnotes/create':
            this.title = 'Nuevo Remito';
            break;
          default:
          this.title = 'Editar Venta';
          break;
        }
      }
    },
  }
</script>

<style scoped>
.modal-mask-product {
  position: fixed;
  z-index: 1050;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(16, 24, 40, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  overflow: hidden;
}

.modal-dialog {
  margin: 0;
  width: 100%;
  max-width: 960px;
}

.modal-content {
  border: 1px solid var(--border-soft);
  border-radius: 12px;
  box-shadow: 0 12px 32px rgba(16, 24, 40, 0.18);
  overflow: hidden;
}

.modal-body {
  max-height: 70vh;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 20px 24px;
}

.modal-enter,
.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-content,
.modal-leave-active .modal-content {
  transform: scale(1.02);
}
</style>
